import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'googleStreetviewLink'
})
export class GoogleStreetviewLinkPipe implements PipeTransform {
  transform(panoId: string) {
    return encodeURI(
      `https://www.google.com/maps/@?api=1&map_action=pano&pano=${panoId}`
    );
  }
}
